import * as React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import { LinkProps } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import Button, { ButtonProps } from '@material-ui/core/Button';
import Countdown from './Countdown';
import HashLink from '../Common/HashLink';
import { getUserData } from '../../api/auth';

const jss = (theme: Theme) => createStyles({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    nextQuiz: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: '40px',
    },
    icon: {
        width: '8em',
        height: '8em',
        fill: theme.palette.text.disabled,
    },
    button: {
        margin: '40px',
    }
});

interface Props {
    getNext: () => any;
    getParticipate: (params: any) => any;
    match: {
        path: string;
    };
    history: {
        push: (path: string) => void;
    };
    classes: {
        container: string;
        nextQuiz: string;
        icon: string;
        button: string;
    }
}

interface State {
    next: any;
    pending: any;
}

class QuizPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            next: null,
            pending: null,
        }
    }

    componentDidMount() {
        this.onMount();
    }

    private onMount = async () => {
        const next = await this.props.getNext();
        if (next && next.state === 'active') {
            // quiz is active check if user has participated yet
            const data = await this.props.getParticipate({
                username: getUserData().username,
                quizId: next.id,
            });
            if (data && data.count === 0) {
                this.setState({ next });
            }
        } else if (next && (next.state === 'starting' || next.state === 'pending')) {
            this.setState({ pending: next });
        }
    }

    private activate = () => {
        const quiz = this.state.pending;
        this.setState({ next: quiz, pending: null });
    }

  	render() {
        const { classes } = this.props;

        if (this.state.next) {
            const QuizLink = (props: LinkProps & ButtonProps)  => (
                <HashLink to={`${this.props.match.path}/${this.state.next.id}`} {...props} />
            );
            return (
                <div className={classes.container}>
                    <Typography variant="h4" align="center" gutterBottom>
                        New Quiz Available!
                    </Typography>
                    <Button
                        className={classes.button}
                        variant="contained"
                        color="primary"
                        size="large"
                        component={QuizLink}
                    >
                        Take the Quiz
                    </Button>
                </div>
            )
        } else if (this.state.pending) {
            return (
                <div className={classes.container}>
                    <Typography variant="h4" align="center" gutterBottom>
                        Next quiz starts in:
                    </Typography>
                    <Countdown
                        to={new Date(this.state.pending.startTime).getTime()}
                        title="Next quiz starts in:"
                        onEnd={this.activate}
                    />
                </div>
            )
        } else {
            return (
                <div className={classes.container}>
                    <Typography variant="h4" align="center" gutterBottom>
                        No currently active quiz, check back later!
                    </Typography>
                    <ErrorOutline className={classes.icon} />
                </div>
            )
        }
	}
}

export default withStyles(jss)(QuizPage);



// WEBPACK FOOTER //
// ./src/components/Quiz/QuizPage.tsx